import React, { useEffect, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePage.css";
import { Helmet } from "react-helmet";
import "../ImportExport/ServicePages.css";

const GSTRegistration = () => {

  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  // ✅ Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="service-page">

      {/* SEO */}
      <Helmet>
        <title>GST Registration Service | Get GSTIN Online in India</title>
        <meta
          name="description"
          content="Get GST registration online in India with expert assistance. Fast GSTIN approval, error-free filing, and complete compliance support."
        />
        <meta
          name="keywords"
          content="GST Registration, GSTIN Registration India, Apply GST Online, GST Filing Service, GST Consultant"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>GST Registration Service</h1>
        <p>Fast & Hassle-Free GST Registration in India</p>
        <button className="hero-btn" onClick={scrollToContact} >
          Get Started Today
        </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Goods and Services Tax (GST) registration is a mandatory requirement
          for businesses in India that meet the prescribed turnover limits or
          are engaged in interstate supply, e-commerce, or specified activities
          under GST law.
        </p>
        <p>
          We provide fast, smooth, and hassle-free GST registration services to
          help your business become fully tax compliant from day one.
        </p>
      </section>

      {/* WHO NEEDS */}
      <section className="service-section">
        <h2>Who Needs GST Registration?</h2>
        <ul>
          <li>Businesses with turnover above the prescribed threshold limit</li>
          <li>E-commerce sellers (Amazon, Flipkart, etc.)</li>
          <li>Inter-state suppliers of goods or services</li>
          <li>Casual taxable persons</li>
          <li>Input service distributors</li>
          <li>Non-resident taxable persons</li>
        </ul>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of GST Registration</h2>
        <ul>
          <li>✔ Legally compliant business operations</li>
          <li>✔ Ability to collect GST from customers</li>
          <li>✔ Claim Input Tax Credit (ITC)</li>
          <li>✔ Expansion across India without restrictions</li>
          <li>✔ Increased business credibility</li>
        </ul>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our GST Registration Services Include</h2>
        <ul>
          <li>Consultation on GST applicability</li>
          <li>Preparation & filing of GST application (REG-01)</li>
          <li>PAN, Aadhaar & document verification</li>
          <li>Business detail validation</li>
          <li>ARN generation & tracking</li>
          <li>Assistance until GSTIN is issued</li>
          <li>Post-registration support</li>
        </ul>
      </section>

      {/* TYPES */}
      <section className="service-section">
        <h2>Types of GST Registration</h2>
        <ul>
          <li>Regular GST Registration</li>
          <li>Composition Scheme Registration</li>
          <li>Casual Taxable Person Registration</li>
          <li>Non-Resident GST Registration</li>
        </ul>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>PAN Card of business/owner</li>
          <li>Aadhaar Card</li>
          <li>Photograph of proprietor/partners/directors</li>
          <li>Address proof of business place</li>
          <li>Bank account details</li>
          <li>Rent agreement or ownership proof (if applicable)</li>
          <li>Authorization letter (for companies/LLP)</li>
        </ul>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>GST Registration Process</h2>
        <ul>
          <li>Document collection & verification</li>
          <li>Application preparation (Form REG-01)</li>
          <li>Online submission on GST portal</li>
          <li>Verification by GST officer</li>
          <li>GSTIN issuance</li>
        </ul>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>
        <ul>
          <li>✔ Quick & hassle-free registration</li>
          <li>✔ Expert GST professionals</li>
          <li>✔ Error-free application filing</li>
          <li>✔ Affordable pricing</li>
          <li>✔ End-to-end support</li>
        </ul>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Start your business with complete GST compliance</h2>
        <p>Get your GST registration done quickly and easily.</p>
        <button>Contact Us</button>
      </section> */}



      <div className="cta" ref={contactRef}>
        <h2>Start your business with complete GST compliance</h2>
        <p>Get your GST registration done quickly and easily.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
        </div>
      </div>



    </div>
  );
};

export default GSTRegistration;